// extracted by mini-css-extract-plugin
export default {"asterisk":"X0AWtXLJ"};